import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Nav, ListGroup } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import { TbLayoutSidebarLeftExpand, TbLayoutSidebarLeftCollapse } from "react-icons/tb";
import { logoutUser } from '../../services/api';

const Sidebar = ({ isOpen, isMinimized, isMobile, toggleSidebar }) => {
    // Define sidebar items
    const mainItems = [
        { link: 'dashboard', icon: <MdIcons.MdOutlineDashboard size={20} />, label: 'Dashboard' },
        { link: 'inventory', icon: <FaIcons.FaBoxes size={16} />, label: 'Inventory' },
        { link: 'itemgroups', icon: <FaIcons.FaLayerGroup size={16} />, label: 'Groups' },
        { link: 'rgp', icon: <FaIcons.FaExchangeAlt size={20} />, label: 'RGP' },
    ];

    const dashboard = [
        { link: 'dashboard', icon: <MdIcons.MdOutlineDashboard size={20} />, label: 'Dashboard' },
    ];

    const inventory = [
        { link: 'inventory', icon: <FaIcons.FaBoxes size={16} />, label: 'Inventory' },
        { link: 'itemgroups', icon: <FaIcons.FaLayerGroup size={16} />, label: 'Item Groups' },
    ];

    const rgp = [
        { link: 'rgp', icon: <FaIcons.FaExchangeAlt size={16} />, label: 'RGP' },
    ];

    const exploreSections = [
        { link: '#', icon: <MdIcons.MdGroup size={20} />, label: 'Clients' },
        { link: '#', icon: <FaIcons.FaUserTie size={16} />, label: 'Employees' },
        { link: '#', icon: <MdIcons.MdOutlineShoppingCart size={20} />, label: 'Sales' },
        { link: '#', icon: <FaIcons.FaStore size={16} />, label: 'Purchases' },
        { link: 'trending', icon: 'trending', label: 'Trending' },
        { link: 'music', icon: 'music', label: 'Music' },
    ];
    
    // Handle click on mobile
    const handleItemClick = () => {
        if (isMobile) {
            toggleSidebar();
        }
    };

    const handleLogout = async () => {
        await logoutUser();
    };

    // Render a single item in the sidebar (full view)
    const renderSidebarItem = (item) => (
        <NavLink 
            to={item.link} 
            className={({ isActive }) => 
                `d-flex align-items-center rounded ${isActive ? 'active bg-gray-50 hover:bg-gray-50 text-gray-800 hover:text-gray-800' : 'hover:bg-gray-800 text-gray-100 hover:text-gray-100'}`
            }
            style={({ isActive }) => ({ 
                // color: isActive ? '#0f0f0f' : '#606060',
                transition: 'all 0.2s ease'
            })}
            key={item.label}
            onClick={handleItemClick}
        >
            <div className="p-2" style={{ display: 'flex', justifyContent: 'center' }}>
                {item.icon}
            </div>
            {!isMinimized && (
                <span style={{ fontSize: '14px' }}>{item.label}</span>
            )}
        </NavLink>
    );

    // Render a single item in the sidebar (minimized view)
    const renderMinimizedItem = (item) => (
        <NavLink 
            to={item.link} 
            className={({ isActive }) => 
                `d-flex flex-column align-items-center justify-content-center p-2 rounded ${isActive ? 'active bg-gray-50 hover:bg-gray-50 text-gray-800 hover:text-gray-800' : 'hover:bg-gray-800 text-gray-100 hover:text-gray-100'}`
            }
            style={({ isActive }) => ({ 
                transition: 'all 0.2s ease'
            })}
            title={item.label}
            key={item.label}
            onClick={handleItemClick}
        >
            <div>
                {item.icon}
            </div>
            {/* <span style={{ fontSize: '10px', marginTop: '4px' }}>{item.label}</span> */}
        </NavLink>
    );

    // If minimized, show only icons with small text below
    if (isMinimized && isOpen && !isMobile) {
        return (
        <div 
            className={`fixed flex flex-column left-0 top-[0px] bottom-0 w-[52px] bg-gray-700 pt-[0px] overflow-y-auto overflow-x-hidden z-[999] ${!isMobile ? 'shadow-md' : 'shadow-lg'}`}
            // style={{ borderRight: '1px solid #e3e3e3' }}
        >
            <div className="px-2 py-2">
            <button 
                className="d-flex flex-column align-items-center justify-content-center p-2 rounded w-100 text-gray-100 hover:bg-gray-800 focus:outline-none" 
                title='Expand Sidebar'
                onClick={toggleSidebar}
            >
                <TbLayoutSidebarLeftExpand size={20} />
            </button>
            </div>
            <Nav className="flex-column" style={{ flex: 1 }}>
            <div className="d-grid gap-1 px-2 mt-3">
                {mainItems.map(renderMinimizedItem)}
            </div>
            </Nav>
            <div className="px-2 pb-2">
                <button 
                    className="nav-link d-flex flex-column align-items-center justify-content-center p-2 rounded w-100 text-gray-100 hover:bg-gray-800 border-0" 
                    style={{ 
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                        ':hover': {
                            backgroundColor: '#f2f2f2'
                        }
                    }}
                    title='Logout'
                    onClick={handleLogout}
                >
                    <div>
                        <MdIcons.MdLogout size={16} />
                    </div>
                    {/* <span style={{ fontSize: '10px' }}>Logout</span> */}
                </button>
            </div>
        </div>
        );
    }

    // If closed on mobile, don't render
    if (!isOpen) {
        return null;
    }

    const userRole = localStorage.getItem('userRole');
    // Full sidebar
    return (
        <div 
        className={`fixed flex flex-column left-0 top-[0px] bottom-0 w-[240px] bg-gray-700 pt-[0px] overflow-y-auto overflow-x-hidden z-[999] ${!isMobile ? '' : 'shadow-lg'}`}
        // style={{ borderRight: '1px solid #e3e3e3' }}
        >
        <div className="px-2 py-2 flex items-center">
            <button 
                className="nav-link inline align-items-center p-2 rounded text-gray-100 hover:bg-gray-800 focus:outline-none" 
                title='Collapse Sidebar'
                onClick={toggleSidebar}
            >
                <div className=''>
                    <TbLayoutSidebarLeftCollapse size={20} />
                    {/* <MdIcons.MdLogout /> */}
                </div>
            </button>
            <Link to="/" className="inline pl-1" style={{ color: '#FF8000' }}
            onClick={handleItemClick}
            >
                <span className='text-gray-50 font-semibold'>Brey
                </span>
                ERP
            </Link>
        </div>
        <Nav className="flex-column px-2" style={{ flex: 1 }}>

            {/* Main navigation section */}
            <div className="mt-3 mb-2">
            {dashboard.map(renderSidebarItem)}
            </div>

            {/* Secondary navigation section */}
            {["super_admin", "admin_user", "item_user"].includes(userRole) && (
            <div className="mb-2">
            <div className="text-gray-300 mb-2 ps-2" style={{ fontSize: '14px' }}>
                Inventory
            </div>
            {inventory.map(renderSidebarItem)}
            </div>
            )}

            {/* Subscriptions section */}
            <div className="mb-2">
            <div className="text-gray-300 mb-2 ps-2" style={{ fontSize: '14px' }}>
                Job Work
            </div>
            {["super_admin", "admin_user", "process_user"].includes(userRole) && (
            <NavLink 
                to="process-sheet" 
                className={({ isActive }) => 
                    `d-flex align-items-center rounded ${isActive ? 'active bg-gray-50 hover:bg-gray-50 text-gray-800 hover:text-gray-800' : 'hover:bg-gray-800 text-gray-100 hover:text-gray-100'}`
                }
                style={({ isActive }) => ({ 
                    // color: isActive ? '#0f0f0f' : '#606060',
                    transition: 'all 0.2s ease'
                })}
                key='Process Sheet'
                onClick={handleItemClick}
            >
                <div className="p-2" style={{ display: 'flex', justifyContent: 'center' }}>
                    <FaIcons.FaFileAlt size={16} />
                </div>
                {!isMinimized && (
                    <span style={{ fontSize: '14px' }}>Process Sheet</span>
                )}
            </NavLink>
            )}
            {["super_admin", "admin_user", "item_user"].includes(userRole) && (
            <>
            {rgp.map(renderSidebarItem)}
            </>
            )}
            </div>

            {/* Explore section */}
            {/* <div className="my-3">
            <div className="text-muted mb-2 ps-2" style={{ fontSize: '14px' }}>
                EXPLORE
            </div>
            {exploreSections.map(renderSidebarItem)}
            </div> */}
        </Nav>

        <button className="mx-2 my-2 flex items-center text-gray-100 hover:bg-gray-800 rounded-lg focus:outline-none"
            onClick={handleLogout}
        >
            <div className='p-2'>
                <MdIcons.MdLogout size={16} style={{ marginLeft: '2px' }} />
                {/* <MdIcons.MdLogout /> */}
            </div>
            <span className="inline pb-1" style={{ fontSize: '14px' }}>
                Logout
            </span>
            {/* <span style={{ fontSize: '14px' }}>Logout</span> */}
        </button>
        </div>
    );
};

export default Sidebar;